import { Link } from "react-router-dom";
import RegCompleted from "../../assets/img/completed.webp";

export const RegistrationCompleted = () => {
  return (
    <section id="login-container">
      <div className="container">
        <div className="row d-flex justify-content-center align-items-center">
          <div className="col-md-6">
            <img
              src={RegCompleted}
              className="img-fluid"
              alt="Reset Password"
            />
          </div>
          <div className="col-md-5">
            <h4 className="text-center py-3">
              Your account has been successfully set up! You're all set to log
              in and explore.
            </h4>
            <center>
              <Link to={"/"} className={`btn btn-primary col-md-6`}>
                Go to Login
              </Link>
            </center>
          </div>
        </div>
      </div>
    </section>
  );
};
